module.exports = __webpack_public_path__ + "bc8a6a2857d15f3130a44dcf17bb1e31.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/profiles/profiles.html
// module id = 2136
// module chunks = 0